import { Grid } from '@mui/material';
import { useContext, useLayoutEffect } from 'react';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import IssueReportInfo from './IssueReportInfo';
import { makePermittedIssueReportListSelector } from '../../selector/issueReportsSelector';
import { HeaderRightButtonContext } from '../../layout/MainLayout';
import IssueReportsCommands from '../../action/issueReportsCommands';
import IssueReportUnavailable from './IssueReportUnavailable';
import IssueReportComments from './IssueReportComments';

const IssueReportDetailsPage = () => {
    const dispatch = useDispatch();
    const headerRightButton = useContext(HeaderRightButtonContext);
    const params = useParams<{ issueReportId: string }>();
    const issueReportId = params.issueReportId || '';

    const permittedIssueReports = useSelector(makePermittedIssueReportListSelector());

    const issueReport = permittedIssueReports.find((issueReport) => issueReport.id === issueReportId);

    // Layout effect: the refetch below must mark the list as loading before
    // the first paint, or a list already 'loaded' without this report flashes
    // "no longer exists" for a frame.
    useLayoutEffect(() => {
        headerRightButton.setButtonState({ isCancelButton: true, previousRoute: '/issue-reports' });

        // On a hard refresh of the detail URL, the list isn't loaded yet.
        // The per-id saga writes to a different state slice than the page
        // reads from, so re-use the list fetcher (same as the index page)
        // to populate `issueReports` — the selector below picks up the row.
        // Archived reports included: a direct link (e.g. a goodwill code's
        // "View report") may point at an archived one, and leaving it out
        // would report an existing report as gone.
        if (!issueReport) {
            dispatch(IssueReportsCommands.fetchIssueReports({ includeArchived: true }));
        }

        // Disarm the X on unmount — without this, navigating back (e.g.
        // to the all-tenant view) leaves a stale cancel button that still
        // points at this tenant's /issue-reports list.
        return () => {
            headerRightButton.setButtonState({ isCancelButton: false, previousRoute: '' });
        };
    }, [params.issueReportId]);


    if (!issueReport) {
        return <IssueReportUnavailable />;
    }



    return (
        <Grid container={true} spacing={2}>
            <Grid item={true} xs={12} md={6}>
                <IssueReportInfo issueReport={issueReport!} />
            </Grid>
            <Grid item={true} xs={12} md={6}>
                <IssueReportComments issueReport={issueReport!} />
            </Grid>
        </Grid>
    );
};

export default IssueReportDetailsPage;
